import { apiClient } from './client';

export interface ShopCspDomain {
  id: number;
  domain: string;
}

export function listCspDomains (shopId: number | string) {
  return apiClient.get<{ data: ShopCspDomain[] }>(`/${shopId}/shop-csp-domains`);
}

export function createCspDomain (shopId: number | string, domain: string) {
  return apiClient.post<{ data: ShopCspDomain }>(`/${shopId}/shop-csp-domains`, { domain });
}

export function updateCspDomain (shopId: number | string, domainId: number, domain: string) {
  return apiClient.patch<{ data: ShopCspDomain }>(`/${shopId}/shop-csp-domains/${domainId}`, { domain });
}

export function deleteCspDomain (shopId: number | string, domainId: number) {
  return apiClient.delete(`/${shopId}/shop-csp-domains/${domainId}`);
}
